// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jei6","toggle":"styles_toggle__3Qaub","preview":"styles_preview__3qBq-"};